import { render, staticRenderFns } from "./RecSidebar.vue?vue&type=template&id=523f2fd0&"
import script from "./RecSidebar.vue?vue&type=script&lang=js&"
export * from "./RecSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports